import ToggleCustomField from "components/Inputs/ToggleCustomField";

const FieldTypeToggle = ({
  fieldValues,
  setFieldValues,
  showModificationProtection,
}) => {
  const handleValueChange = (name, val) => {
    setFieldValues((prev) => ({ ...prev, [name]: val }));
  };

  return (
    <>
      <ToggleCustomField
        className="mb-2"
        message="Display name for true value of Toggle"
        inputValue={fieldValues.trueDisplayName}
        onChange={(val) => handleValueChange("trueDisplayName", val)}
        disabled={fieldValues.protected && !showModificationProtection}
      />
      <ToggleCustomField
        className="my-4"
        message="Display name for false value for Toggle"
        inputValue={fieldValues.falseDisplayName}
        onChange={(val) => handleValueChange("falseDisplayName", val)}
        disabled={fieldValues.protected && !showModificationProtection}
      />
    </>
  );
};

export default FieldTypeToggle;
